/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedWheelchairIcon16Light = forwardRef('MedWheelchairIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5.495A2.25 2.25 0 0 0 5 4.94v4.056a1 1 0 0 0 1 1h4.337L12.2 13.72a.515.515 0 0 0 .67.223l1.5-.75a.5.5 0 1 0-.446-.894l-1.053.526-1.638-3.276a1 1 0 0 0-.895-.553H6v-2h3.5a.5.5 0 0 0 0-1H6V4.94A2.25 2.25 0 0 0 5.5.495Zm-1.25 2.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z" }),
        React.createElement("path", { d: "M3.405 6.956a.5.5 0 0 0-.65-.76 5 5 0 1 0 7.195 6.87.5.5 0 1 0-.79-.614 4 4 0 1 1-5.756-5.496Z" })));
});
